/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useCallback, useRef, useState } from "react";
import styled from "styled-components";

import Box from "../Box";
import Icon from "../Icon";

type Props = {
  src: string;
  placeholder?: string;
  type: string;
  dimensions: string;
  muted?: boolean;
};

const VideoInner = Box;
const VideoContainer = styled(Box).attrs({
  position: "relative",
})`
  margin: 0 auto;

  video,
  .mask {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .mask {
    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background: rgba(0, 0, 0, 0.2);
      z-index: 2;
    }
    img {
      position: relative;
      z-index: 0;
      width: 100%;
    }
    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      cursor: pointer;
      z-index: 5;
      filter: drop-shadow(0px 4px 14px rgba(42, 42, 42, 0.12))
        drop-shadow(0px 1px 4px rgba(42, 42, 42, 0.2));
    }
  }
`;

const Video: React.FC<Props> = ({ src, placeholder, type, dimensions, muted = true }) => {
  const [playing, setPlaying] = useState(false),
    videoRef = useRef<HTMLVideoElement>(),
    playVideo = useCallback(() => {
      videoRef.current.play().catch(() => {
        videoRef.current.muted = muted;
        return videoRef.current.play();
      });
    }, [muted]);

  const [width, height] = dimensions.split("x").map(d => Number(d)),
    videoContainerProps = { width: "100%", maxWidth: width },
    videoInnerProps = { width: "100%", pb: `${(height / width) * 100}%` };

  if (!src) return null;

  return (
    <VideoContainer {...videoContainerProps}>
      <VideoInner {...videoInnerProps}>
        {playing ? (
          <video ref={videoRef} poster={placeholder} controls autoPlay onCanPlay={playVideo}>
            <source src={src} type={`video/${type.toLowerCase().replace("mov", "mp4")}`} />
            <p>Sorry, this video can&apos;t be played in this browser.</p>
          </video>
        ) : (
          <div className="mask">
            {placeholder && <img src={placeholder} />}
            <Icon onClick={() => setPlaying(true)} fill="white" iconId="play-video" size="60" />
          </div>
        )}
      </VideoInner>
    </VideoContainer>
  );
};

export default Video;
